import React from 'react'
import { useCableEvent } from 'lib/live_events'

function ActivityFeed(props) {
  useCableEvent('activity-update', (data) => {
    console.log(data)
  })

  return <div className="activity-feed">

  </div>
}

export default ActivityFeed